import React from "react";
// import { Link } from "react-router-dom";
import "isomorphic-fetch";
import { firestore, storage } from "../helpers/Firebase";

// import Footer from "../Common/Footer";

class Contact extends React.Component {
  state = {
    submitting: false,
    submitted: false,
    buttonState: "",
    formFields: {
      name: "",
      ridistrict: "",
      designation: "",
      tshirtsize: "",
      district: "",
      code: "",
      email: "",
      number: "",
      message: "",
      riid: "",
      isPaulHarrisFellow: false,
      complimentaryPhf: false,
      agree: false,
      punedarshan: false,
    },
    submitButton: "Submit Data",
    regBlank: true,
    regError: false,
    ids: [],
    error: false,
    loaded: false,
    loadingLogo: false,
    loadingPhoto: false,
    loadingAadhar: false,
    fakeData: false,
  };

  getTime = async () => {
    const time = await fetch(
      "http://worldtimeapi.org/api/timezone/Asia/Kolkata"
    ).then((res) => res.json());
    console.log("time", new Date(time.datetime).toLocaleDateString());
    // const ref = firestore.collection("coupon").doc("code");
    // const data = { codes: value };
    // ref.update(data).then(() => console.log("Uploaded"));
  };

  // onSubmit = (e) => {
  //     e.preventDefault();
  //     if (!this.regBlank && this.regError) {
  //         return;
  //     }
  //     const data = this.state.formFields;
  //     console.log('data', data, JSON.stringify(data));
  //     fetch('https://script.google.com/macros/s/AKfycby1SenSInFP1gXFw2MIdba2pGeukiIttqh-5ta8DnXi9TuWjoSnYDoeWNc91tUjO7E1/exec', {
  //         method: 'POST',
  //         headers: {
  //             'Content-Type': 'application/x-www-form-urlencoded',
  //         },
  //         body: JSON.stringify(data)
  //     }).then(res => {
  //         if (res.status === 200) {
  //             this.setState({ submitted: true })
  //         }
  //         let formFields = Object.assign({}, this.state.formFields);
  //         formFields.name = '';
  //         formFields.email = '';
  //         formFields.number = '';
  //         formFields.message = '';
  //         this.setState({formFields});
  //         console.log('success', res);
  //     }).catch(error => console.log('error', error));
  // }
  loadData = () => {
    const ref = firestore.collection("coupon").doc("code");
    ref.onSnapshot((doc) => {
      this.setState({ ids: doc.data().codes, loaded: true });
    });
  };

  // loadFakeData = () => {
  //     const ref = firestore.collection('coupon').doc('code');
  //     const data = { codes: couponArray };
  //     ref.update(data).then(() => this.setState({ fakeData: true }));

  // }

  onSubmit = async (e) => {
    e.preventDefault();
    this.setState({
      submitting: true,
      submitted: false,
      error: false,
      submitButton: "Submitting...",
    });
    const data = this.state.formFields;
    // const newDate = new Date(data.dob).toLocaleDateString("en-GB");
    // data.dob = newDate;
    let options = {
      timeZone: 'Asia/Kolkata',
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
  };
    const time = await fetch(
      "https://worldtimeapi.org/api/timezone/Asia/Kolkata"
    ).then((res) => res.json());
    const currentTime = new Date(time.datetime).toLocaleDateString('en-IN', options);
    data.timestamp = currentTime;
    let loadingAadhar = false;
    let loadingLogo = false;
    let loadingPhoto = false;
    let loadingAppointmentLetter = false;

    if (data.appointmentLetter) {
      const fileRef = storage
        .ref()
        .child(`appointmentLetter/${data.code}`)
        .put(data.appointmentLetter);
      await fileRef
        .then((snapshot) => {
          const { bucket } = snapshot.metadata;
          const fullPath = `appointmentLetter%2F${data.code}`;
          const logoUrl = `https://firebasestorage.googleapis.com/v0/b/${bucket}/o/${fullPath}?alt=media`;
          data.appointmentLetter = logoUrl;
          // console.log("logo", data);
          loadingAppointmentLetter = true;
        })
        .catch((err) => console.log("err", err));
    } else {
      loadingAppointmentLetter = true;
    }

    if (data.aadhar) {
      const fileRef = storage
        .ref()
        .child(`aadhar/${data.code}`)
        .put(data.aadhar);
      await fileRef
        .then((snapshot) => {
          const { bucket } = snapshot.metadata;
          const fullPath = `aadhar%2F${data.code}`;
          const logoUrl = `https://firebasestorage.googleapis.com/v0/b/${bucket}/o/${fullPath}?alt=media`;
          data.aadhar = logoUrl;
          // console.log("logo", data);
          loadingAadhar = true;
        })
        .catch((err) => console.log("err", err));
    } else {
      loadingAadhar = true;
    }

    if (data.logo) {
      const fileRef = storage.ref().child(`logos/${data.code}`).put(data.logo);
      await fileRef
        .then((snapshot) => {
          const { bucket } = snapshot.metadata;
          const fullPath = `logos%2F${data.code}`;
          const logoUrl = `https://firebasestorage.googleapis.com/v0/b/${bucket}/o/${fullPath}?alt=media`;
          data.logo = logoUrl;
          // console.log("logo", data);
          loadingLogo = true;
        })
        .catch((err) => console.log("err", err));
    } else {
      loadingLogo = true;
    }

    if (data.photo) {
      const fileRef = storage
        .ref()
        .child(`photos/${data.code}`)
        .put(data.photo);
      await fileRef
        .then((snapshot) => {
          const { bucket } = snapshot.metadata;
          const fullPath = `photos%2F${data.code}`;
          const photoUrl = `https://firebasestorage.googleapis.com/v0/b/${bucket}/o/${fullPath}?alt=media`;
          data.photo = photoUrl;
          // console.log("photo", data);
          loadingPhoto = true;
        })
        .catch((err) => console.log("err", err));
    } else {
      loadingPhoto = true;
    }
    const formData = new URLSearchParams();
    for (const [key, value] of Object.entries(data)) {
      formData.append(key, value);
    }
    if (
      !this.state.regBlank &&
      !this.state.regError &&
      loadingLogo &&
      loadingPhoto &&
      loadingAadhar &&
      loadingAppointmentLetter
    ) {
      fetch(
        "https://script.google.com/macros/s/AKfycby1SenSInFP1gXFw2MIdba2pGeukiIttqh-5ta8DnXi9TuWjoSnYDoeWNc91tUjO7E1/exec",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: formData.toString(),
        }
      )
        .then((res) => {
          if (res.status === 200) {
            this.setState({ submitted: true });
            const value = this.state.ids;
            const index = value.findIndex((i) => i === data.code);
            const testing = data.code === 'TESTING';
            if (index >= 0 && !testing) {
              // console.log("delerting", index);
              value.splice(index, 1);
              const ref = firestore.collection("coupon").doc("code");
              const data = { codes: value };
              ref.update(data).then(() => this.loadData());
              // console.log("final", data);
            }
            // console.log("ids", this.state.ids, index);
          }
          let formFields = {
            name: "",
            ridistrict: "",
            designation: "",
            tshirtsize: "",
            district: "",
            code: "",
            email: "",
            number: "",
            message: "",
            riid: "",
            isPaulHarrisFellow: false,
            complimentaryPhf: false,
            agree: false,
            punedarshan: false,
          };
          this.setState({
            formFields,
            submitting: false,
            submitButton: "Submit Data",
          });
          const logoField = document.getElementById("logo");
          logoField.value = "";
          const photoField = document.getElementById("photo");
          photoField.value = "";
          const aadharField = document.getElementById("aadhar");
          aadharField.value = "";
          const appointmentLetterField =
            document.getElementById("appointmentLetter");
          appointmentLetterField.value = "";
          // console.log("success", res);
          // console.log("ids", this.state.ids);
        })
        .catch((error) => {
          // console.log("error", error);
          this.setState({
            error: true,
            submitting: false,
            submitButton: "Submit Data",
          });
        });
    } else {
      this.setState({
        error: true,
        submitting: false,
        submitButton: "Submit Data",
      });
    }
  };

  nameChangeHandler = (e) => {
    let formFields = Object.assign({}, this.state.formFields);
    formFields.name = e.target.value;
    this.setState({ formFields });
  };
  codeChangeHandler = (e) => {
    const enteredCode = e.target.value;
    let formFields = { ...this.state.formFields };
    let regBlank = this.state.regBlank;
    let regError = this.state.regError;

    if (enteredCode.length > 0) {
      regBlank = false;
    } else {
      regBlank = true;
    }

    if (this.state.ids.includes(enteredCode)) {
      regError = false;
    } else {
      regError = true;
    }

    formFields.code = enteredCode;
    this.setState({ formFields, regBlank, regError });
    // console.log("test3", regBlank, regError, this.regBlank);
  };

  ridistrictChangeHandler = (e) => {
    let formFields = Object.assign({}, this.state.formFields);
    formFields.ridistrict = e.target.value;
    this.setState({ formFields });
  };

  riidChangeHandler = (e) => {
    let formFields = Object.assign({}, this.state.formFields);
    formFields.riid = e.target.value;
    this.setState({ formFields });
  };

  designationChangeHandler = (e) => {
    let formFields = Object.assign({}, this.state.formFields);
    formFields.designation = e.target.value;
    this.setState({ formFields });
  };

  tshirtsizeChangeHandler = (e) => {
    let formFields = Object.assign({}, this.state.formFields);
    formFields.tshirtsize = e.target.value;
    this.setState({ formFields });
  };

  
  districtChangeHandler = (e) => {
    let formFields = Object.assign({}, this.state.formFields);
    formFields.district = e.target.value;
    this.setState({ formFields });
  };

  // codeChangeHandler = (e) => {
  //     let formFields = Object.assign({}, this.state.formFields);
  //     formFields.code = e.target.value;
  //     this.setState({ formFields });
  // }

  emailChangeHandler = (e) => {
    let formFields = Object.assign({}, this.state.formFields);
    formFields.email = e.target.value;
    this.setState({ formFields });
  };

  numberChangeHandler = (e) => {
    let formFields = Object.assign({}, this.state.formFields);
    const input = e.target.value;
    const numberOnly = input.replace(/\D/g, "");
    formFields.number = numberOnly;
    this.setState({ formFields });
  };

  logoChangeHandler = (e) => {
    let formFields = Object.assign({}, this.state.formFields);
    formFields.logo = e.target.files[0];
    console.log("logo", e.target.files[0], formFields);
    this.setState({ formFields });
  };

  photoChangeHandler = (e) => {
    let formFields = Object.assign({}, this.state.formFields);
    formFields.photo = e.target.files[0];
    console.log("photo", e.target.files[0], formFields);
    this.setState({ formFields });
  };

  aadharChangeHandler = (e) => {
    let formFields = Object.assign({}, this.state.formFields);
    formFields.aadhar = e.target.files[0];
    this.setState({ formFields });
  };
  appointmentLetterChangeHandler = (e) => {
    let formFields = Object.assign({}, this.state.formFields);
    formFields.appointmentLetter = e.target.files[0];
    this.setState({ formFields });
  };

  isPaulHarrisFellowChangeHandler = (e) => {
    console.log(e.target.value);
    let formFields = Object.assign({}, this.state.formFields);
    formFields.isPaulHarrisFellow = !formFields.isPaulHarrisFellow;
    this.setState({ formFields });
  };
  
  punedarshanChangeHandler = (e) => {
    console.log(e.target.value);
    let formFields = Object.assign({}, this.state.formFields);
    formFields.punedarshan = !formFields.punedarshan;
    this.setState({ formFields });
  };
  

  complimentaryPhfChangeHandler = (e) => {
    console.log(e.target.value);
    let formFields = Object.assign({}, this.state.formFields);
    formFields.complimentaryPhf = !formFields.complimentaryPhf;
    this.setState({ formFields });
  };
  agreeChangeHandler = (e) => {
    console.log(e.target.value);
    let formFields = Object.assign({}, this.state.formFields);
    formFields.agree = !formFields.agree;
    this.setState({ formFields });
  };

  textChangeHandler = (e) => {
    let formFields = Object.assign({}, this.state.formFields);
    formFields.message = e.target.value;
    this.setState({ formFields });
  };

  onHideSuccess = () => {
    this.setState({ submitted: false });
  };

  onHideError = () => {
    this.setState({ error: false });
  };
  successMessage = () => {
    if (this.state.submitted) {
      return (
        <div
          className="alert alert-success alert-dismissible fade show"
          style={{ marginTop: "14px" }}
        >
          <strong>Thank you for Registration.</strong> See you at RZI Pune 2024!
          {/* <button
                        type="button"
                        className="close"
                        onClick={this.onHideSuccess}
                    >
                        <span aria-hidden="true">&times;</span>
                    </button> */}
        </div>
      );
    }
    if (this.state.error) {
      return (
        <div
          className="alert alert-error alert-dismissible fade show"
          style={{ marginTop: "14px" }}
        >
          <strong>Error!</strong> Validate Registration Code.
          {/* <button
                        type="button"
                        className="close"
                        onClick={this.onHideError}
                    >
                        <span aria-hidden="true">&times;</span>
                    </button> */}
        </div>
      );
    }
  };

  render() {
    if (this.state.ids.length < 1) {
      this.loadData();
    }
    // if (!this.state.fakeData) {
    //     this.loadFakeData();
    // }
    // console.log("loaded", this.state.loaded);
    if (!this.state.loaded) {
      return null;
    }

    return (
      <React.Fragment>
        {/* <div className="page-title-area item-bg1">
                    <div className="container">
                        <h1>Contact Us</h1>
                        <span>Send me your Message</span>
                        <ul>
                            <li><Link to="/">Home</Link></li>
                            <li>Contact</li>
                        </ul>
                    </div>
                </div> */}

        <section id="register" className="contact-area ptb-120">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-4 col-md-6">
                <div className="contact-box">
                  <div className="icon">
                    <i className="icofont-phone"></i>
                  </div>

                  <div className="content">
                    <h4>Registration Head</h4>
                    <p>PDRR Akshay More - 9673734448</p>
                  </div>
                </div>
              </div>

              <div className="col-lg-4 col-md-6">
                <div className="contact-box">
                  <div className="icon">
                    <i className="icofont-email"></i>
                  </div>

                  <div className="content">
                    <h4>E-mail</h4>
                    <p>rzipune2024@gmail.com</p>
                  </div>
                </div>
              </div>

              {/* <div className="col-lg-4 col-md-6 offset-lg-0 offset-md-3">
                                <div className="contact-box">
                                    <div className="icon">
                                        <i className="icofont-world"></i>
                                    </div>

                                    <div className="content">
                                        <h4>Location</h4>
                                        <p>2750 Quadra Street Victoria, City, Canada</p>
                                    </div>
                                </div>
                            </div> */}
            </div>

            <div className="row h-100 align-items-center contact-form">
              {/* <div className="col-lg-4 col-md-12">
                                <div className="leave-your-message">
                                    <h3>Leave Your Message</h3>
                                    <p>If you have any questions about the services we provide simply use the form below. We try and respond to all queries and comments within 24 hours.</p>

                                    <div className="stay-connected">
                                        <h3>Stay Connected</h3>
                                        <ul>
                                            <li>
                                                <Link to="#" target="_blank">
                                                    <i className="icofont-facebook"></i>
                                                    <span>Facebook</span>
                                                </Link>
                                            </li>

                                            <li>
                                                <Link to="#" target="_blank">
                                                    <i className="icofont-twitter"></i>
                                                    <span>Twitter</span>
                                                </Link>
                                            </li>

                                            <li>
                                                <Link to="#" target="_blank">
                                                    <i className="icofont-instagram"></i>
                                                    <span>Instagram</span>
                                                </Link>
                                            </li>

                                            <li>
                                                <Link to="#" target="_blank">
                                                    <i className="icofont-linkedin"></i>
                                                    <span>Linkedin</span>
                                                </Link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div> */}

              <div className="col-lg-12 col-md-12">
                <form onSubmit={this.onSubmit} id="contactForm">
                  <div className="row">
                    <div className="col-lg-12 col-md-12">
                      <div className="form-group">
                        <label htmlFor="name">Full Name*</label>
                        <input
                          type="name"
                          className="form-control"
                          name="name"
                          id="name"
                          required={true}
                          data-error="Please enter full name "
                          value={this.state.formFields.name}
                          onChange={this.nameChangeHandler}
                        />
                      </div>
                    </div>

                    <div className="col-lg-6 col-md-6">
                      <div className="form-group">
                        <label htmlFor="text">RI District*</label>
                        <input
                          type="text"
                          className="form-control"
                          name="ridistrict"
                          id="ridistrict"
                          required={true}
                          data-error="Please enter RI District"
                          value={this.state.formFields.ridistrict}
                          onChange={this.ridistrictChangeHandler}
                        />
                        <div className="help-block with-errors"></div>
                      </div>
                    </div>

                    <div className="col-lg-6 col-md-6">
                      <div className="form-group">
                        <label htmlFor="date">RIID*</label>
                        <input
                          type="text"
                          className="form-control"
                          name="riid"
                          id="riid"
                          required={true}
                          data-error="Please enter riid"
                          value={this.state.formFields.riid}
                          onChange={this.riidChangeHandler}
                        />
                        <div className="help-block with-errors"></div>
                      </div>
                    </div>

                    <div className="col-lg-12 col-md-12">
                      <div className="form-group">
                        <label htmlFor="designation">
                          Current Designation*
                        </label>
                        <select
                          className="form-control"
                          name="designation"
                          id="designation"
                          required={true}
                          data-error="Please select a designation"
                          value={this.state.formFields.designation}
                          onChange={this.designationChangeHandler}
                        >
                          <option value=""> Select Current Designation</option>
                          <option value="DRR Elect">
                            District Rotaract Representative Elect
                          </option>
                          <option value="DRR Nominee">
                            District Rotaract Representative Nominee
                          </option>
                          <option value="DRR">
                            District Rotaract Representative
                          </option>
                          <option value="DRS">
                            District Rotaract Secretary Elect
                          </option>
                          <option value="DRS">
                            District Rotaract Secretary Nominee
                          </option>
                          <option value="DRR">
                            District Rotaract Secretary
                          </option>
                          <option value="IPDRR">
                            Immediate Past District Rotaract Representative
                          </option>
                          <option value="PDRR">
                            Past District Rotaract Representative
                          </option>
                          <option value="Guest (Rotarians)">
                            Guest (Rotarians)
                          </option>
                          <option value="DG">District Governor</option>
                          <option value="DYSD">
                            District Youth Service Director
                          </option>
                          <option value="DRS">
                            District Rotaract Committee Chair
                          </option>
                        </select>
                        <div className="help-block with-errors"></div>
                      </div>
                    </div>
                    {(this.state.formFields.designation === "DRR Elect" ||
                      this.state.formFields.designation === "DRR Nominee") && (
                      <div className="col-lg-12 col-md-12">
                        <div className="form-group">
                          <label htmlFor="logo">
                            Appointment Letter by serving District Governor*
                          </label>

                          <input
                            type="file"
                            className="form-control"
                            name="appointmentLetter"
                            id="appointmentLetter"
                            required={
                              (this.state.formFields.designation ===
                                "DRR Elect" ||
                                this.state.formFields.designation ===
                                  "DRR Nominee") &&
                              true
                            }
                            data-error="Please upload Appointment letter"
                            onChange={this.appointmentLetterChangeHandler}
                          />
                          <div className="help-block with-errors"></div>
                        </div>
                      </div>
                    )}
                    <div className="col-lg-6 col-md-6">
                      <div className="form-group">
                        <label htmlFor="email">Area covered by district*</label>
                        <input
                          type="text"
                          className="form-control"
                          name="district"
                          id="district"
                          required={true}
                          data-error="Please enter Area covered by dist"
                          value={this.state.formFields.district}
                          onChange={this.districtChangeHandler}
                        />
                        <div className="help-block with-errors"></div>
                      </div>
                    </div>

                    <div className="col-lg-6 col-md-6">
                      <div className="form-group">
                        <label htmlFor="code">Registration code*</label>
                        <input
                          type="text"
                          className="form-control"
                          name="code"
                          id="code"
                          required={true}
                          data-error="Please upload Coupon code"
                          value={this.state.formFields.code}
                          onChange={this.codeChangeHandler}
                        />
                        {!this.state.regBlank && this.state.regError ? (
                          <div
                            style={{
                              padding: "5px",
                              backgroundColor: "lightred",
                            }}
                          >
                            Error
                          </div>
                        ) : null}
                      </div>
                    </div>

                    <div className="col-lg-6 col-md-6">
                      <div className="form-group">
                        <label htmlFor="number">WhatsApp no*</label>

                        <input
                          type="tel"
                          className="form-control"
                          name="number"
                          id="number"
                          required={true}
                          data-error="Please enter your WhatsApp number"
                          value={this.state.formFields.number}
                          onChange={this.numberChangeHandler}
                        />
                        <div className="help-block with-errors"></div>
                      </div>
                    </div>

                    <div className="col-lg-6 col-md-6">
                      <div className="form-group">
                        <label htmlFor="email">Email*</label>
                        <input
                          type="email"
                          className="form-control"
                          name="email"
                          id="email"
                          required={true}
                          data-error="Please enter your email"
                          value={this.state.formFields.email}
                          onChange={this.emailChangeHandler}
                        />
                        <div className="help-block with-errors"></div>
                      </div>
                    </div>

                    <div className="col-lg-6 col-md-6">
                      <div className="form-group">
                        <label htmlFor="logo">Aadhar card/Passport*</label>

                        <input
                          type="file"
                          className="form-control"
                          name="aadhar"
                          id="aadhar"
                          required={true}
                          data-error="Please upload Aadhar card/Passport"
                          onChange={this.aadharChangeHandler}
                        />
                        <div className="help-block with-errors"></div>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                      <div className="form-group">
                        <label htmlFor="photo">Professional Photo*</label>

                        <input
                          type="file"
                          className="form-control"
                          name="photo"
                          id="photo"
                          required={true}
                          data-error="Please upload Professional Photo"
                          onChange={this.photoChangeHandler}
                        />
                        <div className="help-block with-errors"></div>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                      <div className="form-group">
                        <label htmlFor="logo">District logo (optional)</label>

                        <input
                          type="file"
                          className="form-control"
                          name="logo"
                          id="logo"
                          // required={true}
                          // data-error="Please enter your WhatsApp number"
                          onChange={this.logoChangeHandler}
                        />
                        <div className="help-block with-errors"></div>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                      <div className="form-group">
                        <label htmlFor="designation">
                          T-Shirt Size* <a href="https://firebasestorage.googleapis.com/v0/b/rzi-event.appspot.com/o/rzi_tshirt_size.jpg?alt=media" target="_blank" style={{textDecoration:'underline', fontSize: '12px', marginLeft: '4px'}}>Check Size</a>
                        </label>
                        <select
                          className="form-control"
                          name="tshirtsize"
                          id="tshirtsize"
                          required={true}
                          data-error="Please select a T-Shirt Size"
                          value={this.state.formFields.tshirtsize}
                          onChange={this.tshirtsizeChangeHandler}
                        >
                          <option value=""> Select T-Shirt Size</option>
                          <option value="S">
                           S
                          </option>
                          <option value="M">
                            M
                          </option>
                          <option value="L">
                            L
                          </option>
                          <option value="XL">
                            XL
                          </option>
                          <option value="XXL">
                          XXL
                          </option>
                          <option value="XXXL">
                          XXXL
                          </option>
                          
                        </select>
                        <div className="help-block with-errors"></div>
                      </div>
                    </div>

                    <div className="col-lg-12 col-md-12">
                          <div className="form-group">
                            <label htmlFor="number">
                            Do you want to enroll for Pune Darshan ride to be provided by us on 24th March 2024?*

                            </label>
                            <div className="d-flex ">
                              <div className="d-flex justify-center align-center">
                                <input
                                  type="radio"
                                  name="punedarshan"
                                  value={true}
                                  checked={
                                    this.state.formFields.punedarshan ===
                                    true
                                  }
                                  onChange={
                                    this.punedarshanChangeHandler
                                  }
                                />
                                <span style={{ paddingLeft: "5px" }}>Yes</span>
                              </div>
                              <div
                                className="d-flex justify-center align-center"
                                style={{ paddingLeft: "20px" }}
                              >
                                <input
                                  type="radio"
                                  name="punedarshan"
                                  value={false}
                                  checked={
                                    this.state.formFields.punedarshan ===
                                    false
                                  }
                                  onChange={
                                    this.punedarshanChangeHandler
                                  }
                                />
                                <span style={{ paddingLeft: "5px" }}>No</span>
                              </div>
                            </div>

                            <div className="help-block with-errors"></div>
                          </div>
                    </div>
                    <div className="row col-lg-12 col-md-12">
                      {(this.state.formFields.designation === "DRR Elect" ||
                        this.state.formFields.designation ===
                          "DRR Nominee") && (
                        <div className="col-lg-6 col-md-6">
                          <div className="form-group">
                            <label htmlFor="number">
                              Are you a Paul Harris Fellow?
                            </label>
                            <div className="d-flex ">
                              <div className="d-flex justify-center align-center">
                                <input
                                  type="radio"
                                  name="isPaulHarrisFellow"
                                  value={true}
                                  checked={
                                    this.state.formFields.isPaulHarrisFellow ===
                                    true
                                  }
                                  onChange={
                                    this.isPaulHarrisFellowChangeHandler
                                  }
                                />
                                <span style={{ paddingLeft: "5px" }}>Yes</span>
                              </div>
                              <div
                                className="d-flex justify-center align-center"
                                style={{ paddingLeft: "20px" }}
                              >
                                <input
                                  type="radio"
                                  name="isPaulHarrisFellow"
                                  value={false}
                                  checked={
                                    this.state.formFields.isPaulHarrisFellow ===
                                    false
                                  }
                                  onChange={
                                    this.isPaulHarrisFellowChangeHandler
                                  }
                                />
                                <span style={{ paddingLeft: "5px" }}>No</span>
                              </div>
                            </div>

                            <div className="help-block with-errors"></div>
                          </div>
                        </div>
                      )}
                      {(this.state.formFields.designation === "DRR Elect" ||
                        this.state.formFields.designation === "DRR Nominee") &&
                        this.state.formFields.isPaulHarrisFellow === false && (
                          <div className="col-lg-6 col-md-6">
                            <div className="form-group">
                              <label htmlFor="number">
                                If No, would you like to opt for Complimentary
                                PHF award from Team RZI Pune?
                              </label>
                              <div className="d-flex ">
                                <div className="d-flex justify-center align-center">
                                  <input
                                    type="radio"
                                    name="complimentaryPhf"
                                    value={true}
                                    checked={
                                      this.state.formFields.complimentaryPhf ===
                                      true
                                    }
                                    onChange={
                                      this.complimentaryPhfChangeHandler
                                    }
                                  />
                                  <span style={{ paddingLeft: "5px" }}>
                                    Yes
                                  </span>
                                </div>
                                <div
                                  className="d-flex justify-center align-center"
                                  style={{ paddingLeft: "20px" }}
                                >
                                  <input
                                    type="radio"
                                    name="complimentaryPhf"
                                    value={false}
                                    checked={
                                      this.state.formFields.complimentaryPhf ===
                                      false
                                    }
                                    onChange={
                                      this.complimentaryPhfChangeHandler
                                    }
                                  />
                                  <span style={{ paddingLeft: "5px" }}>No</span>
                                </div>
                              </div>

                              <div className="help-block with-errors"></div>
                            </div>
                          </div>
                        )}
                    </div>

                    <div className="col-lg-10 col-md-10">
                      <div className="form-group">
                        <div
                          className="d-flex"
                          style={{ gap: "10px", alignItems: "start" }}
                        >
                          <input
                            type="checkbox"
                            name="agree"
                            required={
                              this.state.formFields.complimentaryPhf === true
                            }
                            value={true}
                            checked={this.state.formFields.agree === true}
                            onChange={this.agreeChangeHandler}
                            style={{ marginTop: "5px" }}
                          />
                          <label htmlFor="agree">
                            I agree that the above information is true to my
                            knowledge
                            {this.state.formFields.complimentaryPhf === true &&
                              ", and if I opt for the above PHF application, I will not be allowed to Swap or withdraw my Registration. DRRE and DRRN shall be awarded PHF only if he/she attends the RZI graduation 2024 - Pune."}
                          </label>
                        </div>

                        <div className="help-block with-errors"></div>
                      </div>
                    </div>

                    <div className="col-lg-12 col-md-12 ">
                      <button
                        type="submit"
                        className="btn btn-primary text-center"
                      >
                        <span
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignContent: "center",
                          }}
                        >
                          {this.state.submitButton}
                          {this.state.submitting && (
                            <div
                              class="spinner-border"
                              role="status"
                              style={{
                                width: "1rem",
                                height: "1rem",
                                marginLeft: "5px",
                              }}
                            >
                              <span class="sr-only">Loading...</span>
                            </div>
                            // <div className="loading-bar">
                            //     <div className="bar"></div>
                            // </div>
                          )}
                        </span>
                      </button>

                      <div id="msgSubmit" className="h3 text-center hidden">
                        {this.successMessage()}
                      </div>
                      <div className="clearfix"></div>
                    </div>
                  </div>
                </form>
                {/* <button
                  onClick={this.getTime}
                  className="btn btn-primary text-center"
                >
                  <span
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignContent: "center",
                    }}
                  >
                    Get
                  </span>
                </button> */}
              </div>
            </div>
          </div>
        </section>
        {/* <Footer /> */}
      </React.Fragment>
    );
  }
}

export default Contact;
